import { Languages } from "../../types";
import { companyDataDictionary } from "./CompanyData";
import { settingsDictionary } from "./Settings";
import { systemSettingsDictionary } from "./SystemSettings";
import { SettingsPagesDescriptions } from "./types";

export const getSettingsDescriptions = (systemLang: Languages): SettingsPagesDescriptions => ({
    SETTINGS: settingsDictionary[systemLang],
    SYSTEM_SETTINGS: systemSettingsDictionary[systemLang],
    COMPANY_DATA: companyDataDictionary[systemLang],
})